import { Reveal, SectionHead } from "@/components/Reveal";
import { ArrowUpRight } from "lucide-react";

const CHAPTERS = [
  {
    num: "01",
    title: "Physical Non-Ferrous Mastery",
    body: "Direct sourcing and trading of premium scrap copper — Millberry, Berry/Candy, Birch/Cliff — aluminum 6063 extrusions, and Zorba fractions, graded to ISRI specification with precision assay verification.",
    tags: ["Cu Scrap", "Al 6063", "Zorba", "ISRI"],
  },
  {
    num: "02",
    title: "Exchange & OTC Risk Hedging",
    body: "Zero-cost collars, tailored OTC swaps, and live mark-to-market P&L tracking across LME, COMEX, and SME — engineered to lock margins and neutralize price volatility on physical books.",
    tags: ["LME", "COMEX", "SME", "OTC Swaps"],
  },
  {
    num: "03",
    title: "Global Container Freight Networks",
    body: "End-to-end containerized logistics across Qingdao, Ashdod, Jebel Ali, Mundra, Nhava Sheva, Laem Chabang, and Istanbul — with full customs and HS 7601 / 7604 compliance.",
    tags: ["7 Port Hubs", "HS 7601", "HS 7604"],
  },
];

export default function Chapters() {
  return (
    <section id="about" data-testid="chapters-section" className="py-20 lg:py-32">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-8 lg:px-16">
        <SectionHead
          index="/01"
          overline="Core Competencies"
          title="Bridging physical scrap supply chains with sophisticated derivative risk management."
          subtitle="Three disciplines, one integrated trading discipline — metal in the yard, paper on the exchange, cargo on the water."
          testId="chapters-head"
        />
        <div className="border-t border-[#283244]">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.num} delay={i * 0.08}>
              <div
                data-testid={`chapter-${c.num}`}
                className="group grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-10 py-12 lg:py-16 border-b border-[#283244] items-start transition-colors duration-500 hover:bg-[#111620]/50 lg:px-6 -mx-0 lg:-mx-6"
              >
                <div className="lg:col-span-2">
                  <span className="font-display font-black text-5xl lg:text-7xl text-transparent transition-all duration-500"
                    style={{ WebkitTextStroke: "1.5px #283244" }}
                  >
                    <span className="group-hover:[-webkit-text-stroke:1.5px_#E06D28] transition-all duration-500">{c.num}</span>
                  </span>
                </div>
                <div className="lg:col-span-4">
                  <h3 className="font-display text-xl sm:text-2xl font-bold text-[#F4F6F8] group-hover:text-[#F07D38] transition-colors duration-300 flex items-center gap-3">
                    {c.title}
                    <ArrowUpRight size={20} className="opacity-0 -translate-x-1 translate-y-1 group-hover:opacity-100 group-hover:translate-x-0 group-hover:translate-y-0 transition-all duration-300 text-[#E06D28]" />
                  </h3>
                </div>
                <div className="lg:col-span-4">
                  <p className="text-base text-[#94A3B8] leading-relaxed">{c.body}</p>
                </div>
                <div className="lg:col-span-2 flex flex-wrap gap-2 lg:justify-end">
                  {c.tags.map((t) => (
                    <span key={t} className="font-mono-tech text-[11px] uppercase tracking-wider text-[#64748B] border border-[#283244] group-hover:border-[#E06D28]/40 px-3 py-1.5 rounded-full transition-colors duration-300">
                      {t}
                    </span>
                  ))}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
